const PROJECTS_DATA = [
    {
        id: 1,
        name: "ROCK PAPER SCISSOR",
        link: "https://rsp262610.netlify.app/",
        github: "https://github.com/mukulrajpoot262610",
        day: "Day-1",
        image: "/images/1.jpg",
        tags: ["#CONDITIONS", "#FUNCTIONS", "#VANILLAJS"],
        head: "it is the rock paper scissor game made with HTML, CSS, JS, learned conditional rendering and some routing in vanilla",
    },
    {
        id: 2,
        name: "BANKIST",
        link: "https://bankist-mr.netlify.app/",
        github: "https://github.com/mukulrajpoot262610",
        day: "Day-2",
        image: "/images/2.jpg",
        tags: ["#ARRAYS", "#FUNCTIONS", "#VANILLAJS", "#AUTH"],
        head: "it is the bank application named BANKIST, learned a lot about arrays and their important methods"
    },
    {
        id: 3,
        name: "JOKE TELLER",
        link: "https://joke-teller-mr.netlify.app/",
        github: "https://github.com/mukulrajpoot262610",
        day: "Day-3",
        image: "/images/3.jpg",
        tags: ["#API", "#JOKE", "#SPEECHTOTEXT", "#JSON"],
        head: "joke teller application made with Javascript, learned a lot about APIs, it also include TEXT TO SPEECH API",
    },
    {
        id: 4,
        name: "PORTFOLIO",
        link: "https://mukulrajpoot.netlify.app/",
        github: "https://github.com/mukulrajpoot262610",
        day: "Day-4",
        image: "/images/4.jpg",
        tags: ["#JS", "#CSS", "#ANIMATIONS", "#SPA"],
        head: "It is my Personal Portfolio website made with REACTJS, learned a lot about parallax, some CSS animations and advanced DOM manipulation"
    },
    {
        id: 5,
        name: "TRACKIT",
        link: "https://trackit-mr.netlify.app/",
        github: "https://github.com/mukulrajpoot262610",
        day: "Day-5",
        image: "/images/5.jpg",
        tags: ["#JS", "#API", "#WEATHER", "#COVID", "#NEWS"],
        head: "It is biggest Application made with VANILLA JS, learned a lot about APIs, including MAP, handle CORS and some JS routing"
    },
    {
        id: 6,
        name: "FORTY NINTH WEBSITE",
        link: "https://fortynine-mr.netlify.app/",
        github: "https://github.com/mukulrajpoot262610",
        day: "Day-6",
        image: "/images/6.jpg",
        tags: ["#SPA", "#REACT"],
        head: "It is the simple single page website made with REACT to practice basic components and Routing in DOM"
    },
    {
        id: 7,
        name: "VEGSHOP",
        link: "https://vegshop-mr.netlify.app/",
        github: "https://github.com/mukulrajpoot262610",
        day: "Day-7",
        image: "/images/7.jpg",
        tags: ["#ECOMMERCE", "#REACT", "#CONTEXT", "#REDUCER"],
        head: "It is the complete E-commerce application made with REACT and CONTEXT, learned a lot about state management"
    },
    {
        id: 8,
        name: "HOUSE MART WEBSITE",
        link: "https://housemart-mr.netlify.app/",
        github: "https://github.com/mukulrajpoot262610",
        day: "Day-8",
        image: "/images/8.jpg",
        tags: ["#WEBSITE", "#REACT", "#SPA", "#ANIMATION"],
        head: "It is the simple website focused on designing part, learned a lot about CSS Grid, and some cool animations library like framer-motion"
    },
]

export default PROJECTS_DATA